import React from 'react';
import { PageTitleZone } from '../../../../components/page-title-zone';

export function BulkCourseEnrollmentTitleZone() {
  return <PageTitleZone entityName="Fremmødeforløb" title="Opret fremmødeforløb" />;
}
